/** React Query hooks for expert learnings CRUD. */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { tradingApi } from '../services/tradingApi';
import type { LearningFilters } from '../types/expert';

export function useLearnings(params: LearningFilters = {}) {
  return useQuery({
    queryKey: ['expert-learnings', params],
    queryFn: () => tradingApi.getLearnings(params),
  });
}

export function useLearning(id: number) {
  return useQuery({
    queryKey: ['expert-learning', id],
    queryFn: () => tradingApi.getLearning(id),
    enabled: !!id,
  });
}

export function useCreateLearning() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: {
      content: string;
      level?: string;
      domain?: string;
      symbol?: string;
      strategy?: string;
      user_id?: number;
    }) => tradingApi.createLearning(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['expert-learnings'] });
    },
  });
}

export function useUpdateLearning() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: {
      id: number;
      data: {
        content?: string;
        level?: string;
        domain?: string;
        symbol?: string;
        strategy?: string;
        status?: string;
      };
    }) => tradingApi.updateLearning(params.id, params.data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['expert-learnings'] });
    },
  });
}

export function useDeleteLearning() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => tradingApi.deleteLearning(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['expert-learnings'] });
    },
  });
}
